import { LogOut, Building2, Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { usePortalAuth } from '@/hooks/usePortalAuth';
import PortalSwitcher from './PortalSwitcher';

interface PortalHeaderProps {
  onMenuToggle: () => void;
}

const PortalHeader = ({ onMenuToggle }: PortalHeaderProps) => {
  const { signOut, user } = useAuth();
  const { company, role } = usePortalAuth();

  const handleSignOut = async () => {
    await signOut('/portal/auth');
  };

  return (
    <header className="h-16 border-b border-border bg-card px-4 md:px-6 flex items-center justify-between">
      <div className="flex items-center gap-3">
        {/* Mobile hamburger menu */}
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          onClick={onMenuToggle}
        >
          <Menu className="h-5 w-5" />
        </Button>

        <div className="p-2 bg-primary/10 rounded-lg">
          <Building2 className="h-5 w-5 text-primary" />
        </div>
        <div className="hidden sm:block">
          <h1 className="font-semibold text-foreground">
            {company?.name || 'Monument Company Portal'}
          </h1>
          <p className="text-xs text-muted-foreground capitalize">
            {role || 'Loading...'}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <PortalSwitcher />
        <span className="text-sm text-muted-foreground hidden sm:block">
          {user?.email}
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleSignOut}
          className="gap-2"
        >
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">Sign Out</span>
        </Button>
      </div>
    </header>
  );
};

export default PortalHeader;